import { Component, Vue, Mixins } from 'vue-property-decorator'
import { ResultQuestion, SProblem } from './WebApi'
import AlignedWebApi from './AlignedWebApi'
import { QuestionsMemoMathType } from '@/types/memo'

export interface ResultQuestionAligned extends ResultQuestion {
  userAnswerPath: string
}
export interface ResultProblemAligned {
  sProblem: {
    questions: ResultQuestionAligned[]
  }
}
export interface ResultProblemsAligned {
  problemSortNum: number
  questions: ResultQuestionAligned[]
}

export type SProblemAligned = Omit<SProblem, 'existMovie'> & { resultDrillId: number }

@Component
export default class DrillMethodAligned extends Mixins(AlignedWebApi) {
  protected questionsMemoMath: any = []
  protected isFirstTargetMemoMath: { [key: string]: boolean } = {}

  protected sUnitsUrl(params: { subjectCode: string; subjectId: string; lUnitId: string; type?: string }): string {
    const searchParams = new URLSearchParams({
      subjectId: params.subjectId,
      lUnitId: params.lUnitId,
      subjectCode: params.subjectCode,
      ...(params.type && { type: params.type }),
    })

    return `/student/aligned/s-units?${searchParams.toString()}`
  }
  protected currentQuestionsMemoMath: QuestionsMemoMathType = {
    memoUrl: '',
    memoUrlTeacher: '',
    page: 1,
    questionCode: '',
    questionUrls: [],
    answerUrl: '',
    questionUrlsD: [],
  }
  protected async getMemoDataWithQuestion(questionCode: string, problemSortNumParam?: number) {
    const { problemSortNum, resultDrillId } = this.$route.query
    const problemSortNumber = problemSortNumParam || problemSortNum
    const currentQuestionIndex = this.questionsMemoMath.findIndex(
      (item: any) => item.questionCode === questionCode && Number(item.problemSortNum) === Number(problemSortNumber)
    )

    Vue.prototype.$loading.start()
    const result = await this.viewMemoQuestion({
      problem_sort_num: problemSortNumber as string,
      result_drill_id: resultDrillId as string,
      question_code: questionCode,
    })
    Vue.prototype.$loading.complete()

    this.questionsMemoMath[currentQuestionIndex].memoUrl = result.url
    this.questionsMemoMath[currentQuestionIndex].questionUrls = result.memoPath.m || []
    this.questionsMemoMath[currentQuestionIndex].classCategoryId = result.classCategoryId || 0
    this.questionsMemoMath[currentQuestionIndex].questionUrlsD = result.memoPath.d || []

    return this.questionsMemoMath[currentQuestionIndex]
  }
  protected handleCloseTab(message: string) {
    const isClose = confirm(message)
    if (isClose) {
      window.close()
    }
  }

  protected backToBookmarkDetail(subjectCode: string, questionBookmarkId: string) {
    this.$router.push({
      path: '/student/aligned/bookmark-detail',
      query: {
        subjectCode,
        questionBookmarkId,
      },
    })
  }
}
